import { create } from "zustand";

import { STEP_GROUP } from "@/components/TutorialMode/types";

type TutorialDetailsType = {
  isTutorialOpen: boolean;
  stepIndex: number;
  stepGroup: STEP_GROUP;
  isTutorialActive: boolean;
};

interface TutorialStore {
  tutorialDetails: TutorialDetailsType;
  setTutorialDetails: (details: Partial<TutorialDetailsType>) => void;

  isSettingsOpen: boolean;
  setIsSettingsOpen: (isOpen: boolean) => void;

  companySelectorTutorialStatus: boolean;
  setCompanySelectorTutorialStatus: (isOpen: boolean) => void;
  resetTutorialDetails: () => void;
}

const defaultTutorialDetails: TutorialDetailsType = {
  isTutorialOpen: false,
  stepIndex: 0,
  stepGroup: STEP_GROUP.Default,
  isTutorialActive: false
};

export const useTutorialStore = create<TutorialStore>()((set) => ({
  tutorialDetails: defaultTutorialDetails,

  isSettingsOpen: false,

  companySelectorTutorialStatus: false,
  setCompanySelectorTutorialStatus: (isOpen) =>
    set({ companySelectorTutorialStatus: isOpen }),

  setTutorialDetails: (details) =>
    set((state) => ({
      tutorialDetails: { ...state.tutorialDetails, ...details }
    })),

  setIsSettingsOpen: (isOpen) => set({ isSettingsOpen: isOpen }),

  resetTutorialDetails: () => set({ tutorialDetails: defaultTutorialDetails })
}));
